import React from 'react';
import PropTypes from 'prop-types';

export const TblCell = ({ children, isHeader, isRequired, hasInnerRow }) => {
  const innerContent = isRequired ? <div className="required">{children}</div> : <>{children}</>;

  return (
    <div className="cell" role={isHeader ? 'rowheader' : ''}>
      {hasInnerRow ? <div className="inner-row">{innerContent}</div> : innerContent}
    </div>
  );
};

TblCell.propTypes = {
  children: PropTypes.node,
  isHeader: PropTypes.bool,
  isRequired: PropTypes.bool,
  hasInnerRow: PropTypes.bool,
};
TblCell.defaultProps = {
  children: null,
  isHeader: false,
  isRequired: false,
  hasInnerRow: true,
};
export default TblCell;
